import React, { useState, useEffect, useRef } from 'react';
import classNames from 'classnames';
import { Icon, Link } from 'ui/components';
import styles from './PortalList.module.scss';
import IconLocked from 'ui/icons/icon-global-locked.svg';
import IconUnlocked from 'ui/icons/icon-global-unlocked.svg';
import IconChevronDown from 'ui/icons/icon-global-chevron-up.svg';

export interface PortalListProps {
	title?: string;
	items?: Umbraco.PortalItem[];
	isLoggedIn?: boolean;
}

export const PortalList: React.FC<PortalListProps> = ({ items, title, isLoggedIn }) => {
	const portalRef = useRef(null);
	const [portalListOpen, setPortalListOpen] = useState(false);
	const openPortalList = () => {
		setPortalListOpen(!portalListOpen);
	};
	const handleClickClose = (event) => {
		const element = portalRef.current;
		if (!element.contains(event.target)) {
			setPortalListOpen(false);
		}
	};

	useEffect(() => {
		if (portalListOpen) {
			document.addEventListener('click', handleClickClose);
		}
		return () => document.removeEventListener('click', handleClickClose);
	}, [portalListOpen]);

	return (
		<div className={styles.PortalList}>
			<div ref={portalRef} className={styles.PortalList__portalLink} onClick={openPortalList} aria-selected={portalListOpen}>
				{title && <span>{title}</span>}
				<Icon className={styles.PortalList__iconChevron} size="md">
					<IconChevronDown />
				</Icon>
			</div>
			{portalListOpen && (
				<nav className={styles.PortalList__portalContainer}>
					<ul className={styles.PortalList__portalItemContainer}>
						{items &&
							items.map((item, index) => (
								<li key={index} className={styles.PortalList__portalItems}>
									<Link url={item?.content?.properties?.portalLink?.url} className={styles.PortalList__link}>
										<span
											className={classNames(styles.PortalList__text, {
												[styles.PortalList__text___active]: item?.content?.properties?.portalLink?.name === title,
											})}
										>
											{item?.content?.properties?.portalLink?.name}
										</span>
										{item?.content?.properties?.isRestricted && (
											<Icon className={styles.PortalList__iconLock} size="md">
												<IconLocked />
											</Icon>
										)}
									</Link>
								</li>
							))}
					</ul>
				</nav>
			)}
		</div>
	);
};
